import { Badge, cn } from '@wundo/ui';
import type { ReviewFinding } from '@/lib/conversationReviews.ts';
import { findingClassLabel } from './findingClasses.ts';

export interface FindingPillsProps {
  findings: Pick<ReviewFinding, 'class'>[];
  className?: string;
}

/** One pill per class the reviewer found; a class found twice still reads once. */
export function FindingPills({ findings, className }: FindingPillsProps) {
  const classes = [...new Set(findings.map((finding) => finding.class))];

  if (classes.length === 0) {
    return <span className={cn('text-sm text-ink-muted', className)}>No findings</span>;
  }

  return (
    <span className={cn('flex flex-wrap items-center gap-1', className)}>
      {classes.map((findingClass) => (
        <Badge key={findingClass} tone='neutral'>
          {findingClassLabel(findingClass)}
        </Badge>
      ))}
    </span>
  );
}
